export default {
  pt:{
    nomeunidade: "Direção de Serviços das Infraestruturas e Equipamentos (DSIE)",
    menu:{
      apresentacao: "Apresentação",
      avisos: "Avisos e Comunicados",
      helpdesk: "Suporte/Helpdesk",
      azoto: "Produção de Azoto",
      faq: "Perguntas Frequentes",
      formularios: "Formulários",
    },
    apresentacao:{
      horario: "Horário de Expediente",
      horariosecontactos: "Horário e Contactos",
      email: "Email",
      telefone: "Telefone",
      morada: "Morada",
      conhercerequipa: "Conhecer Equipa",
    },
    avisos:{
      pesquisa: "Pesquisar Avisos"
    },
    forms:{
      pesquisaforms: "Pesquisar Formulários"
    },
    azoto:{
      UMA_LANG_DSIE_AZOTO_T1: "Departamento de Produção de Azoto",
      UMA_LANG_DSIE_AZOTO_D1: `O azoto líquido fornecido pela DPA (Departamento de produção de azoto) é produzido com base num separador de azoto gasoso, que nos permite ter azoto gasoso e líquido com bons graus de pureza. Este separador permite-nos ter azoto livre de óleos, água, impurezas superiores a 0.22um e concentrações de gases residuais muito baixas.<br>
                            <span class=\"dark_fim\">Azoto Líquido - NºCAS:007727-37-9<br>
                            Líquido incolor, não detectável por cheiro<br>
                            Ponto de fusão: -210º C Ponto</span>`,
      UMA_LANG_DSIE_AZOTO_T2: "Equipamento, Segurança e Protecção",
      UMA_LANG_DSIE_AZOTO_D2: `<span class=\"dark\">Segurança:</span><br>
                        - Gás não inflamável;<br>
                        - Não subestimar o risco de asfixa;<br>
                        - Pode provocar queimaduras;<br>
                        <span class=\"dark\">Frases de Segurança:</span><br>
                        - S9 Manter recipiente em local bem ventilado;<br>
                        - S23 Não respirar gases;<br>
                        <span class=\"dark\">Equipamento e Protecção do Utilizador:</span><br>
                        - Proteger os olhos, rosto e a pele de projecções de líquido;<br>
                        - Em caso de ventilação insuficiente, usar equipamento respiratório adequado.<br>
                        - Utilizar luvas criogénicas.<br>
                        - No caso de possível contacto com a pele, deve usar roupa de protecção incluindo luvas, avental, botas, protecção para a cara.
                        Usar vestuário de protecção e luvas adequadas.`,
      UMA_LANG_DSIE_AZOTO_T3: "Manuseamento, Armazenagem e Transporte",
      UMA_LANG_DSIE_AZOTO_D3: `<span class=\"dark\">Mauseamento:</span><br>
                        Impedir a entrada de gelo no recipiente. Utilizar somente equipamentos com especificação apropriada a baixas temperaturas e pressões para o manuseamento de criolíquidos.<br>
                        <span class=\"dark\">Armazenagem:</span><br>
                        Colocar o recipiente em área seca e fresca, em local bem ventilado. Se possível conferir o teor de oxigénio antes de entrar na área de armazenamento. Dar particular atenção em caso de derrame deve-se evitar e prevenir o contacto com as garrafas pressurizadas existentes no local (Garrafas 200 bar). Todos os tipos de aço não são resistentes a baixas temperaturas. O Azoto Líquido pode fragilizar materiais estruturais.<br>
                        <span class=\"dark\">Transporte:</span><br>
                        Evitar o transporte em veículos em que o compartimento de carga não está separado da cabine de condução. Assegurar que o condutor conhece os perigos potenciais da carga e das medidas a tomar em caso de emergência.<br>
                        Em caso de não ser possível efetuar transporte com os vidros da viatura abertos.<br>
                        <span class=\"dark_fim\">Restrição em túnel - C/E: Passagem proibida por túneis das categorias C e D quando transportado em cisternas. Passagem proibida através de túneis da categoria E.</span>`,
      UMA_LANG_DSIE_AZOTO_T4: "Primeiros Socorros",
      UMA_LANG_DSIE_AZOTO_D4: `<span class=\"dark\">Inalação:</span><br>
                        Em elevadas concentrações pode causar asfixia.<br>
                        Se sentir perda de conhecimento ou perda de coordenação por favor abandone o local.
                        Não desenvolva trabalho em locais não ventilados. As vítimas podem não ter percepção da asfixia.<br>
                        <span class=\"dark\">Contacto com a pele e com os olhos:</span><br>
                        Lavar imediatamente os olhos abundantemente com água durante 15 minutos.<br>
                        Em caso e congelação, molhar com água pelo menos durante 15 minutos e colocar uma compressa esterilizada. Consultar médico.`,
      UMA_LANG_DSIE_AZOTO_T5: "Responsabilidade",
      UMA_LANG_DSIE_AZOTO_D5: `Apesar de se tentar indicar as principais precauções a tomar na utilização de Azoto líquido refrigerado, nenhuma responsabilidade será aceite por quaisquer danos ou acidentes que possam ocorrer da utilização deste produto. Informe-se de todas as precauções e compatibilidades de materiais a utilizar. Respeite as normas de segurança.<br>
                        <span class=\"dark_fim\">Assegurar que todas as regulamentações nacionais ou locais são respeitadas.</span>`,
      UMA_LANG_DSIE_AZOTO_T6: "Preçário",
      UMA_LANG_DSIE_AZOTO_D6: `<span class=\"dark\">Azoto Líquido venda externa - 2,75€/litro</span><br>
                        <span class=\"dark\">Azoto Gasoso venda externa - 1,65€/m3</span><br>
                        <span class=\"dark\">Aluguer de Dewar - 50.00€/Semana</span><br>
                        Aos valores indicados acresce o valor de 22% de IVA.<br>
                        Quando o recipiente se encontra a temperatura ambiente, inicialmente todo o azoto líquido transferido referido dewar evapora-se, nesta situação a Universidade da Madeira reserva o direito de um acréscimo de 30% * sobre o azoto líquido fornecido.<br>
                        Aconselhamos a solicitação de orçamento aos nossos serviços, no entanto todos as entregas tem de ser acompanhados por pedido anterior ao fornecimento para os emails a cima indicados.
                        <span class=\"dark_fim\">Informações para fornecimento ou esclarecimentos:<br>Departamento de Produção de Azoto - upa{'@'}uma.pt<br>Rogério Correia - rosilcor{'@'}uma.pt - tel. 291 705002 ext. 5469/5025<br>Cristina Camacho - cris{'@'}uma.pt tel. 291 209400 ext. 6415/5022</span>`,
    },
    list:{
      ano: "Ano",
      designacao: "Designação",
      documentos: "Documentos"
    },
    documentacao:{
      pesquisa: "Pesquisar Documentos"
    },
    semdocumentos: "Sem resultados para apresentar",
    apesquisar: "A pesquisar",
    horario: "Horário de Expediente",
    responsavel: "Responsavel",
    
    semnoticias: "Sem informação para apresentar",
    semdoc: "Sem ligações",
    informacoes: "Informações",
    titulodesc: "Título / Descrição",
    data: "Data",
    pesquisarDocs: "Pesquisar Ligações",
    breadcrumb:{
      homepage: "Homepage",
      sobre: "Sobre",
      admin: "Serviços Administrativos",
      sigla: "DSIE",
    }
  },
  en: {
    menu:{
      apresentacao: "Introduction",
      avisos: "Communications",
      helpdesk: "Helpdesk",
      azoto: "Nitrogen Production",
      faq: "Frequently Asked Questions",
      formularios: "Forms",
    },
    apresentacao:{
      horario: "Office Hours",
      horariosecontactos: "SCHEDULE AND CONTACTS",
      email: "Email",
      telefone: "Telephone",
      morada: "Address",
      conhercerequipa: "Meet the team",
    },
    avisos:{
      pesquisa: "Search for Communications"
    },
    azoto:{
      UMA_LANG_DSIE_AZOTO_T1: "Department of Nitrogen Production",
      UMA_LANG_DSIE_AZOTO_D1: `Liquid Nitrogen provided by DNP (Department of Nitrogen Production) is produced based on a gaseous nitrogen separator, allowing us to have both gaseous and liquid nitrogen with good levels of purity. This separator enables us to have nitrogen free of any oil, water, impurities above 0.22um and very low concentration of waste gas.<br>
                            <span class=\"dark_fim\">Liquid Nitrogen: NºCAS:007727-37-9<br>
                            Colourless Nitrogen, undetectable by smell<br>
                            Fusion Point: -210º C</span>`,
      UMA_LANG_DSIE_AZOTO_T2: "Equipment, Safety and Protection",
      UMA_LANG_DSIE_AZOTO_D2: `<span class=\"dark\">Safety:</span><br>
                        - Non-flammable gas;<br>
                        - Do not underestimate the risk of asphyxia;<br>
                        - It may cause burns;<br>
                        <span class=\"dark\">Safety Phrases:</span><br>
                        - S9 Keep container in a well-ventilated place;<br>
                        - S23 Do not breath in the gases;<br>
                        <span class=\"dark\">Equipment and User Protection:</span><br>
                        - Protect eyes, face and skin from any liquid splashes;<br>
                        - In case of insufficient ventilation, use adequate respiratory equipment;<br>
                        - Use Cryogenic Gloves;<br>
                        - In case of possible skin contact, protection vests should be used, including gloves, apron, boots and face protection. Wear suitable protective clothes and gloves.`,
      UMA_LANG_DSIE_AZOTO_T3: "Handling, Storage and Transportation",
      UMA_LANG_DSIE_AZOTO_D3: `<span class=\"dark\">Handling:</span><br>
                        Prevent any ice from entering the container. Only use equipment that is of appropriate specification for low temperatures and pressures for handling cryoliquids. Contact UPA if questions arise. Follow the Instructions given by the container’s provider for correct handling.<br>
                        <span class=\"dark\">Storage:</span><br>
                        Store the container in a dry and fresh area, in a well-ventilated place. If possible, check beforehand the oxygen content of the storage room. Attention should be given in case spillage occurs. Avoid any contact with pressurized bottles on site (200 bar bottles). Not all types of steel are resistant to low temperatures. Liquid Nitrogen may weaken structural materials.<br>
                        <span class=\"dark\">Transportation:</span><br>
                        Transportation should be avoided in vehicles in which the load compartment is not separate from the driver’s compartment.<br>
                        Ensure that the driver is aware of the potential hazards of the load, and of the measures to be taken in case of emergency.<br>
                        <span class=\"dark_fim\">Restriction in tunnel – C/E: Passage is prohibited by tunnels of categories C and D when transported in tanks. Passage through tunnels of category E is forbidden.</span>`,
      UMA_LANG_DSIE_AZOTO_T4: "First Aid",
      UMA_LANG_DSIE_AZOTO_D4: `<span class=\"dark\">Inhalation:</span><br>
                        In higher concentration, it may cause asphyxia.<br> 
                        If loss of awareness or loss of coordination is experienced, please leave the site. Do not perform any work in unventilated locations. Victims may be unaware of asphyxia.<br>
                        <span class=\"dark\">Contact with skin and eyes:</span><br>
                        Immediately thoroughly rinse the eyes with water for 15 minutes.<br>
                        In case of freezing, wet with water for at least 15 minutes and put a sterile gauze. Consult a doctor.`,
      UMA_LANG_DSIE_AZOTO_T5: "Responsibility",
      UMA_LANG_DSIE_AZOTO_D5: `Although the main precautions to be taken when using refrigerated liquid nitrogen are addressed, no liability will be accepted for any damage or accidents that may occur from the use of this product. Check all the precautions and compatibilities of materials to be used. Respect safety norms.<br>
                        <span class=\"dark_fim\">Ensure that all national or local regulations are being respected.</span>`,
      UMA_LANG_DSIE_AZOTO_T6: "Prices",
      UMA_LANG_DSIE_AZOTO_D6: `<span class=\"dark\">Liquid Nitrogen external sale – 2,73€/litre</span><br>
                        <span class=\"dark\">Gaseous nitrogen external sale – 1,65€/litre</span><br>
                        <span class=\"dark\">Dewar Rental – 50.00€/week</span><br>
                        These amounts are subject to the VAT rate of 22%.<br>
                        When the cointainer is at room temperature, initially, the liquid nitrogen transfered (Dewar) will evaporate. In this particular situation, University of Madeira reserves the right to increase the value by 30% of the delivered liquid nitrogen.<br>
                        It is recommended to request for a quotation for our services. However, all deliveries must be accompanied by previous request to the e-mails mentioned above.
                        <span class=\"dark_fim\">For more information:<br>Department of Nitrogen Production: upa@uma.pt<br>Rogério Correia - rosilcor@uma.pt - tel. 291 705002 ext. 5469/5025<br>
Cristina Camacho - cris@uma.pt tel. 291 209400 ext. 6415/5022</span>`,
    },
    nomeunidade: "Directorate for Infrastructures and Equipment",
    horariosecontactos: "SCHEDULE AND CONTACTS",
    email: "Email",
    telefone: "Telephone",
    morada: "Address",
    forms:{
      pesquisaforms: "Search for Forms"
    },
    list:{
      ano: "Year",
      designacao: "Designation",
      documentos: "Documents"
    },
    documentacao:{
      pesquisa: "Search for Documents"
    },
    apesquisar: "Searching",
    horario: "Office Hours",
    responsavel: "Responsible Person",
    semdocumentos: "No documents to be shown",
    conhercerequipa: "Get to know the team",
    semdoc: "Sem ligações",
    informacoes: "Informations",
    titulodesc: "Título / Descrição",
    data: "Date",
    pesquisarDocs: "Pesquisar Ligações",
    breadcrumb:{
      homepage: "Homepage",
      sobre: "About",
      admin: "Administrative Services",
      sigla: "DGIL",
    }
  }
}